import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core'
// import { ActivatedRoute } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { PlanList } from '../../models/plan-list'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentDataService } from '../../gateways/enrollment-data-service'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { UserDataService } from '../../../user-management/gateways/user-data-service'

@Component({
    selector: 'drugplan',
    templateUrl: 'drug-plan.component.html'
})
export class DrugPlanComponent implements OnInit, OnChanges {
    @Input() disabled: boolean = false
    // @Input() drugPlan: DrugPlan
    @Output() onValueChange: EventEmitter<DrugPlan> = new EventEmitter<DrugPlan>()
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    isValidAgent: boolean
    planYear: number
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    planList: PlanList[] = [] as PlanList[]
    selPlan: string
    AppDate: Date
    EffectiveDate: Date | null
    formValue: string
    // enrollment: DrugPlan
    enrol: EnrollmentViewModel = {} as EnrollmentViewModel
    @Input() enrollmentDrugViewModel: EnrollmentViewModel
    @Input() disableAppRecievDt: boolean
    @Input() AgentOrgID: Number
    disableEffectiveDate: boolean

    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private enrollmentdata: EnrollmentDataService,
        public _global: PortalGlobals,
        private userdataservice: UserDataService
    ) {
        this.disableEffectiveDate = false
    }

    ngOnInit() {
        this.formValue = ''
        if (this.enrollmentDrugViewModel.FORMNAME == 'EXTERNAL') {
            this.formValue = 'EXTERNAL'
        } else if (this.enrollmentDrugViewModel.FORMNAME == 'EXTERNALSMS') {
            this.formValue = 'EXTERNALSMS'
        } else if (this.enrollmentDrugViewModel.FORMNAME == 'DATAENTRY') {
            this.formValue = 'DATAENTRY'
        }
        if (this._global.selectedPlanYear !== undefined) {
            this.planYear = this._global.selectedPlanYear
            if (this.planYear !== undefined && this.planYear !== 0) {
                this.setPageData()
            }
        } else {
            this.userdataservice.currentYear.subscribe((data) => {
                this._global.selectedPlanYear = data
                if (data !== undefined && data !== 0) {
                    this.setPageData()
                }
            })
        }
        this.enrollmentdata.elecPeriod.subscribe((elecPeriod) => {
            if (elecPeriod !== undefined && elecPeriod === 'OpenEnrollment') {
                this.disableEffectiveDate = true
            } else {
                this.disableEffectiveDate = false
            }
        })
    }

    setPageData() {
        this.loadPlanList()

        this.enrollmentdata.data.subscribe((data) => {
            if (data !== undefined && data === 'OpenEnrollment') {
                if (this.enrollmentDrugViewModel !== undefined && this.enrollmentDrugViewModel.EFFDT !== undefined) {
                    if (this.enrollmentDrugViewModel.ISEXTERNALAGENT !== undefined && !this.enrollmentDrugViewModel.ISEXTERNALAGENT) {
                        this.enrollmentDrugViewModel.EFFDT = new Date(this.planYear, 0, 1)
                    }
                    if (this.enrollmentDrugViewModel.EFFDT !== undefined) {
                        this.EffectiveDate = this.enrollmentDrugViewModel.EFFDT
                        this.disableEffectiveDate = true
                    }
                } else {
                    this.enrollmentDrugViewModel.EFFDT = null
                    this.EffectiveDate = null
                    this.disableEffectiveDate = false
                }
            } else if (
                this.formValue !== undefined &&
                (this.formValue === 'EXTERNAL' || this.formValue === 'DATAENTRY') &&
                (this.enrollmentDrugViewModel.ENROLLKEY === undefined || this.enrollmentDrugViewModel.ENROLLKEY === '')
            ) {
                this.setEffectiveDate()
            } else {
                if (this.enrollmentDrugViewModel.EFFDT === undefined || this.enrollmentDrugViewModel.EFFDT === null) {
                    this.setEffectiveDate()
                }
            }
        })
    }

    setEffectiveDate() {
        let currDate = new Date()
        if (currDate.getMonth() == 11) {
            this.enrollmentDrugViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
        } else {
            this.enrollmentDrugViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
        }

        //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
        if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
            if (this.enrollmentDrugViewModel.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                if (this._global.selectedPlanYear > currDate.getFullYear())
                    this.enrollmentDrugViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
        }
        this.disableEffectiveDate = false
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.AgentOrgID !== undefined) {
            this.loadPlanList()
        }
    }

    loadPlanList() {
        this.enrol = this._enrollementGateway.getEnrollmentViewModel()
        console.log(this.enrol.AGENTORGID)
        if (this.enrol.AGENTORGID === undefined) {
            this.enrol.AGENTORGID = 0
        }

        this._enrollementGateway.getPlanList(this.enrol.AGENTORGID, this.planYear.toString()).subscribe((model: PlanList[]) => {
            this.planList = model
            this.getPlanList(this.planList)
            this.setPlanData()
            //this.setData()
        })
    }

    setPlanData() {
        this.enrol = this._enrollementGateway.getEnrollmentViewModel()
        if (this.enrol.EFFDT !== undefined) {
            this.enrollmentDrugViewModel.EFFDT = this.enrol.EFFDT
        }
        if (this.enrol.PLANTYPE !== undefined) {
            this.enrollmentDrugViewModel.PLANTYPE = this.enrol.PLANTYPE
            this.onPlanChange(this.enrol.PLANTYPE)
        }
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }

    // selectedElectionPeriodEvent(selElectionPeriod: string) {
    //    if (selElectionPeriod === 'IEP') {
    //        this.enrollmentDrugViewModel.EFFDT = new Date(this.planYear, 1, 1)
    //    } else {
    //    }
    // }

    updateInfo(fieldName: string, fieldValue: string) {
        this.enrollmentDrugViewModel[fieldName] = fieldValue
        //this._enrollementGateway.setEnrollmentViewModel(this.enrollmentDrugViewModel)
        //  this.onValueChange.emit(this.enrollmentDrugViewModel)
    }

    onPlanChange(planType: string) {
        if (planType !== undefined && planType !== '' && planType !== null) {
            this.enrollmentDrugViewModel.PLANTYPE = planType
            if (this.optionrbPlan !== undefined && this.optionrbPlan !== null) {
                if (this.optionrbPlan.length > 0)
                    this.enrollmentDrugViewModel.PLANTYPENAME = this.optionrbPlan.filter((x) => x.value === planType)[0]?.htmlLabel
            }
        }
    }

    appRecievedDateChange(event: any) {
        this.enrollmentDrugViewModel.APPDT = event
        if (
            this.enrollmentDrugViewModel.APPDT !== undefined &&
            this.enrollmentDrugViewModel.APPDT !== null &&
            (this.enrollmentDrugViewModel.EFFDT === undefined || this.enrollmentDrugViewModel.EFFDT === null)
        ) {
            let currDate = event

            if (currDate.getMonth() == 11) {
                this.enrollmentDrugViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollmentDrugViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollmentDrugViewModel.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear())
                        this.enrollmentDrugViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
        }
        if (
            this.enrollmentDrugViewModel.ISSINGLEGROUP &&
            this.enrollmentDrugViewModel.APPDT !== undefined &&
            this.enrollmentDrugViewModel.APPDT !== null
        ) {
            //If SEP date is null than only defualt it to App Date
            if (this.enrollmentDrugViewModel.SEPEFFDT !== undefined && this.enrollmentDrugViewModel.SEPEFFDT === null) {
                this.enrollmentDrugViewModel.SEPEFFDT = this.enrollmentDrugViewModel.APPDT
            }
        }
    }
}
